// Free-text vendor-name input with a browser-native `<datalist>`
// suggestion list populated from previously-seen vendor names in this
// org. Used in the Receipt Review modal header (let the operator
// correct what OCR pulled) and re-usable from the upload form so the
// two surfaces converge on canonical names without a full vendor
// catalog table.
//
// Uses native `<datalist>` rather than a custom dropdown because the
// value isn't bounded -- the user can type any string and we want
// browser autocomplete UX (arrow-key navigation, fuzzy match) for
// free.
import { useId } from "react";
import { mfgDisabledInputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

type Props = {
  value: string;
  vendors: string[];
  onChange: (next: string) => void;
  /** Called when the input loses focus AND the value has changed --
   *  the parent uses this to PATCH the receipt's vendor_name. */
  onCommit?: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

export function ManufacturingVendorAutocomplete({
  value,
  vendors,
  onChange,
  onCommit,
  placeholder,
  disabled,
  className,
}: Props) {
  const listId = useId();
  return (
    <>
      <input
        type="text"
        className={`${mfgDisabledInputClass} ${className ?? ""}`}
        value={value}
        list={listId}
        placeholder={placeholder ?? "(vendor name)"}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onCommit?.(e.target.value.trim())}
      />
      <datalist id={listId}>
        {vendors.map((v) => (
          <option key={v} value={v} />
        ))}
      </datalist>
    </>
  );
}
